import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfigService } from 'src/app/common/services/config.service';
import { HttpInterceptor } from 'src/app/common/services/httpInterceptor.service';
@Injectable({
    providedIn: 'root'
})
export class NeedHelpService {

    private helpDrawerEvent = new Subject<any>();
    private helpDrawerObservable$ = this.helpDrawerEvent.asObservable();

    constructor(
        private _httpInterceptor: HttpInterceptor

    ) { }
    public PostClickToCall(requestData: any) {
        let url = ConfigService.getInstance().getConfigObject().APIURL.postLeadType;
        url = url.replace('{applicationId}', requestData.payload.applicationId);
        url = url.replace('{leadType}', requestData.payload.leadType);
        return this._httpInterceptor.Post(url, null);
    }

    public setHelpDrawerEvent(eventName: string) {
        if (eventName) {
            return this.helpDrawerEvent.next(eventName);
        }
    }

    public getHelpDrawerObservable() {
        return this.helpDrawerObservable$;
    }
}
